/**
 * JLPT level badge — filled, high-contrast.
 *
 * Variants:
 *  - "md" (default): used on focus-hero cards
 *  - "sm": used in compound rows / dropdowns
 *
 * Falls back to a neutral "JŌYŌ" badge when the kanji isn't on the
 * community-curated new-JLPT list but IS one of the Ministry of
 * Education's Jōyō ("regular-use") kanji. Tooltip explains the
 * distinction so learners don't think it's a bug.
 */
const JLPT_COLOR = {
  N5: "#4A6D7C", // calm blue (easiest)
  N4: "#6E7A5A", // moss
  N3: "#D29C4C", // amber
  N2: "#B86C45", // burnt orange
  N1: "#8B4546", // deep red
};
const JOUYOU_COLOR = "#5C5752"; // neutral sumi tone

const JOUYOU_TITLE =
  "Jōyō kanji — a 'regular-use' character every Japanese school " +
  "graduate is expected to know. You can add it to your learning list, " +
  "but it isn't generally tested in the JLPT independently.";

export default function JlptBadge({ level, jouyou = false, size = "md", className = "" }) {
  const isJouyouOnly = !level && jouyou;
  if (!level && !isJouyouOnly) return null;
  const color = level ? JLPT_COLOR[level] || "#7A746D" : JOUYOU_COLOR;
  const label = level || "JŌYŌ";
  const title = level ? `JLPT ${level}` : JOUYOU_TITLE;
  const testId = level ? `jlpt-badge-${level}` : "jouyou-badge";
  const big = size === "md";
  return (
    <span
      data-testid={testId}
      title={title}
      className={`inline-flex items-center font-sans font-bold tracking-[0.18em] text-washi shadow-sm ${
        big ? "px-2.5 py-1 text-xs" : "px-1.5 py-0.5 text-[10px]"
      } ${className}`}
      style={{ background: color }}
    >
      {label}
    </span>
  );
}

export { JLPT_COLOR };
